"use client";

import { useQuery } from "@tanstack/react-query";

import { logAndThrow } from "@/src/lib/logging/logger";
import { getFaxLocationAssignment } from "@/src/requests/fax-location-assignment";

export const FAX_LOCATION_ASSIGNMENT_CACHE_KEY = "fax-location-assignment";

export function useFaxLocationAssignment(taskId: string | null, options?: { enabled?: boolean }) {
  const { data, isFetching, isLoading, isError } = useQuery({
    queryKey: [FAX_LOCATION_ASSIGNMENT_CACHE_KEY, taskId],
    queryFn: async () => {
      if (!taskId) {
        logAndThrow("Task ID is required to fetch fax location assignment");
      }

      return await getFaxLocationAssignment(taskId);
    },
    enabled: options?.enabled !== false && !!taskId,
  });

  return {
    referralLocation: data?.referralLocation ?? null,
    authLocation: data?.authLocation ?? null,
    staffLocation: data?.staffLocation ?? null,
    faxRecipientNumber: data?.faxRecipientNumber ?? null,
    resolvedAssignment: data?.resolvedAssignment ?? null,
    locationPrefix: data?.locationPrefix ?? null,
    isFetching,
    isLoading,
    isError,
  };
}
